import { gsap } from "gsap";


var indexBtn = document.querySelectorAll(".products-index-main__btn");
window.addEventListener(
  "load",
  () => {
    gsap.timeline()
    .to(indexBtn, { opacity: 1, scale: 1.1, duration: .3, ease: "ease:Linear.easeNone" }, .5)
    .to(indexBtn, { scale: 1, duration: .1, ease: "ease:Linear.easeNone"}, .79)

    .add(function() {
      for(let i = 0; i < indexBtn.length; i++) {
        indexBtn[i].classList.add("display");
      }
    }, .8)
  },
  false
);


var wrapper = document.querySelector(".products-index-main__blc");
for(let i = 0; i < indexBtn.length; i++) {
  indexBtn[i].addEventListener(
    "mouseenter",
    (e) => {
      let productsName = e.currentTarget.dataset.name;
      wrapper.classList.add("hover");
      document.querySelector(".products-index-main__btn--" + productsName).classList.add("target");
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to(".products-index-main__fig--main", { opacity: 0, duration: 0.5 }, 0)
        .to(".products-index-main__fig--" + productsName, { opacity: 1, duration: 0.5 }, 0);
    },
    false
  );
  indexBtn[i].addEventListener(
    "mouseleave",
    (e) => {
      let productsName = e.currentTarget.dataset.name;
      wrapper.classList.remove("hover");
      document.querySelector(".products-index-main__btn--" + productsName).classList.remove("target");
      gsap
        .timeline({
          defaults: {
            ease: "power2.out",
          },
        })
        .to(".products-index-main__fig--main", { opacity: 1, duration: 0.5 }, 0)
        .to(".products-index-main__fig--" + productsName, { opacity: 0, duration: 0.5 }, 0);
    },
    false
  );
}
